import React, {Component} from 'react';
import Modal from 'react-modal';
import REST from "../Shared/REST";
import DialogBox from "../Shared/DialogBox";

Modal.setAppElement('body');

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '45%'
    }
};

class ReportBugForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            done: false,
            submitting: false,
            name: "",
            email: "",
            type:"Teacher management",
            device:"Windows PC",
            browser:"Chrome",
            description: "",
            isOpen: false,
            modalDialog: false,
            responseContent:''
        };

        this.submitForm = this.submitForm.bind(this);
        this.handleDescription = this.handleDescription.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleDeviceChange = this.handleDeviceChange.bind(this);
        this.handleBrowserChange = this.handleBrowserChange.bind(this);
        this.bugReportOpen = this.bugReportOpen.bind(this);
    }

    bugReportOpen() {
        this.setState({
            isOpen: !this.state.isOpen,
            name:"",
            email:"",
            type:"Teacher management",
            device: "Windows PC",
            browser: "Chrome",
            description:"",
            done:false,
            submitting:false
        });
    }

    handleNameChange(v) {
        this.setState({
            name: v.target.value
        });
    }

    handleTypeChange(e) {
        this.setState({
            type: e.target.value
        });
    }

    handleDeviceChange(e) {
        this.setState({
            device: e.target.value
        });
    }

    handleBrowserChange(e) {
        this.setState({
            browser: e.target.value
        });
    }

    handleEmailChange(v) {
        this.setState({
            email: v.target.value
        });
    }

    handleDescription(v) {
        this.setState({
            description: v.target.value
        });
    }

    async submitForm() {
        this.setState({
            submitting: true
        });
        let data ={
            name:this.state.name,
            description : this.state.description,
            eMail:this.state.email,
            type:this.state.type,
            device:this.state.device,
            browser:this.state.browser,
        };

        await REST.reportBug(data).then(res=>{
            this.setState({
                done:true,
                submitting:false
            });
            this.setState({
                modalDialog: true,
                responseContent:"The bug report has been successfully sent."

            });
            setTimeout(()=>{this.setState({modalDialog:false}); this.bugReportOpen();},3500);
        }).catch(err=>{
            console.log(err);
            this.setState({
                done:true,
                submitting:false
            });
            this.setState({
                modalDialog: true,
                responseContent:"An error occurred, please try again."

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });

    }

    render() {

        return (
            <div className="navbar fr" style={{marginBottom:0, marginTop:15}}>
                <a onClick={this.bugReportOpen} className="handBtn">
                    <span>Bug Report</span>
                </a>
                <Modal isOpen={this.state.isOpen} style={customStyle}>
                    <div className="modal-content content">
                        <div className="modal-header">
                            <div className="clearfix"></div>
                            <h2>Report Bug Form</h2>
                        </div>
                        <div className={"modal-body"}>
                            <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                            <div className="row">
                                <div className="col-md-12 bgGrey roundCorners">
                                    <h4>If you leave your email address we will get back to you.</h4>
                                    <form className="form">
                                        <h4>Name</h4>
                                        <input onChange={this.handleNameChange} type="text"
                                               className="form-control" placeholder="Name" required autoFocus/>
                                        <h4 style={{marginTop:-10}}>Email Address</h4>
                                        <input onChange={this.handleEmailChange} type="email"
                                               className="form-control" placeholder="Email Address" required/>
                                        <h4 style={{marginTop:-10}}>Where is the bug:</h4>
                                        <select value={this.state.type} className={"form-control"} onChange={this.handleTypeChange}>
                                            <option value="Login Error" title="Login Error">Login Error</option>
                                            <option value="Content Errors" title="Content Errors">Content Errors</option>
                                            <option value="Navigation issues" title="Navigation issues">Navigation issues</option>
                                            <option value="Frozen/Dropped Pages" title="Frozen/Dropped Pages">Frozen/Dropped Pages</option>
                                            <option value="Teacher Management" title="Teacher Management">Teacher Management</option>
                                            <option value="Other" title="Other">Other</option>
                                        </select>
                                        <h4>What is the device:</h4>
                                        <select value={this.state.device} className={"form-control"} onChange={this.handleDeviceChange}>
                                            <option value="Windows PC" title="Windows PC">Windows PC</option>
                                            <option value="Windows Laptop" title="Windows Laptop">Windows Laptop</option>
                                            <option value="Mac PC/Laptop" title="Mac PC/Laptop">Mac PC/Laptop</option>
                                            <option value="ChromeBook" title="ChromeBook">ChromeBook</option>
                                            <option value="iPad" title="iPad">iPad</option>
                                            <option value="Android Tablet" title="Android Tablet">Android Tablet</option>
                                            <option value="Other" title="Other">Other</option>
                                        </select>
                                        <h4>What is the browser:</h4>
                                        <select value={this.state.browser} className={"form-control"} onChange={this.handleBrowserChange}>
                                            <option value="Chrome" title="Chrome">Chrome</option>
                                            <option value="FireFox" title="FireFox">FireFox</option>
                                            <option value="Sarafi" title="Sarafi">Sarafi</option>
                                            <option value="IE" title="IE">IE</option>
                                            <option value="Other" title="Other">Other</option>
                                        </select>
                                        <h4>Describe the bug (and name the student assessment if relevant).</h4>
                                        <textarea rows={4} onChange={this.handleDescription} placeholder="Bug description."
                                                  required className="form-full-textarea"></textarea>

                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <a onClick={this.bugReportOpen} className="handBtn"><span>Close</span></a>
                            <a disabled={this.submitting || this.state.done} onClick={this.submitForm}
                               className="handBtn" type="submit"><span>Submit</span></a>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default ReportBugForm;
